import { baseRestApi } from "api/rest/baseRestApi";

type QueryParams = {
  conversationId: number;
};

type QueryArgs = {
  queryParams: QueryParams;
  body: {
    is_started?: boolean;
  };
};

type Response = {};

module.hot?.accept();

const updateConversationApi = baseRestApi.enhanceEndpoints({ addTagTypes: ["CONVERSATIONS"] }).injectEndpoints({
  overrideExisting: module.hot?.status() === "apply",
  endpoints: (builder) => ({
    updateConversation: builder.mutation<Response, QueryArgs>({
      query: ({ queryParams, body }) => ({
        url: `/shipper/conversations/${queryParams.conversationId}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: [{ type: "CONVERSATIONS" }],
    }),
  }),
});

export default updateConversationApi;
export const { useUpdateConversationMutation } = updateConversationApi;
